import * as actions from './batchActions';

const initialState = {
    // Batches list
    batches: [],
    loadingBatches: false,
    errorBatches: null,

    // Batch detail
    currentBatch: null,
    loadingBatchDetail: false,
    errorBatchDetail: null,

    // Notes
    notes: [],
    loadingNotes: false,
    errorNotes: null,

    // Images
    images: [],
    loadingImages: false,
    errorImages: null,

    // UI State
    filters: {
        status: '',
        strain: '',
        organization: '',
        batch_code: '',
        date_from: '',
        date_to: '',
        contaminated: null,
        active: true
    },
    selectedBatch: null,
};

export default function batchReducer(state = initialState, action) {
    switch (action.type) {
        // ==================== FETCH BATCHES ====================
        case actions.FETCH_BATCHES.REQUEST:
            return { ...state, loadingBatches: true, errorBatches: null };

        case actions.FETCH_BATCHES.SUCCESS:
            return {
                ...state,
                batches: action.payload,
                loadingBatches: false,
                errorBatches: null
            };

        case actions.FETCH_BATCHES.FAILURE:
            return { ...state, loadingBatches: false, errorBatches: action.payload };

        // ==================== FETCH BATCH DETAIL ====================
        case actions.FETCH_BATCH_DETAIL.REQUEST:
            return { ...state, loadingBatchDetail: true, errorBatchDetail: null };

        case actions.FETCH_BATCH_DETAIL.SUCCESS:
            return {
                ...state,
                currentBatch: action.payload,
                loadingBatchDetail: false,
                errorBatchDetail: null
            };

        case actions.FETCH_BATCH_DETAIL.FAILURE:
            return { ...state, loadingBatchDetail: false, errorBatchDetail: action.payload };

        // ==================== CREATE BATCH ====================
        case actions.CREATE_BATCH.REQUEST:
            return { ...state, loadingBatches: true, errorBatches: null };

        case actions.CREATE_BATCH.SUCCESS:
            return {
                ...state,
                batches: [action.payload, ...state.batches],
                loadingBatches: false,
                errorBatches: null
            };

        case actions.CREATE_BATCH.FAILURE:
            return { ...state, loadingBatches: false, errorBatches: action.payload };

        // ==================== UPDATE BATCH ====================
        case actions.UPDATE_BATCH.REQUEST:
        case actions.UPDATE_BATCH_STATUS.REQUEST:
            return { ...state, loadingBatchDetail: true, errorBatchDetail: null };

        case actions.UPDATE_BATCH.SUCCESS:
        case actions.UPDATE_BATCH_STATUS.SUCCESS:
            return {
                ...state,
                currentBatch: action.payload,
                batches: state.batches.map(batch =>
                    batch.id === action.payload.id ? action.payload : batch
                ),
                loadingBatchDetail: false,
                errorBatchDetail: null
            };

        case actions.UPDATE_BATCH.FAILURE:
        case actions.UPDATE_BATCH_STATUS.FAILURE:
            return { ...state, loadingBatchDetail: false, errorBatchDetail: action.payload };

        // ==================== DELETE BATCH ====================
        case actions.DELETE_BATCH.REQUEST:
            return { ...state, loadingBatches: true, errorBatches: null };

        case actions.DELETE_BATCH.SUCCESS:
            return {
                ...state,
                batches: state.batches.filter(batch => batch.id !== action.payload.batchId),
                loadingBatches: false,
                errorBatches: null
            };

        case actions.DELETE_BATCH.FAILURE:
            return { ...state, loadingBatches: false, errorBatches: action.payload };

        // ==================== NOTES ====================
        case actions.FETCH_BATCH_NOTES.REQUEST:
            return { ...state, loadingNotes: true, errorNotes: null };

        case actions.FETCH_BATCH_NOTES.SUCCESS:
            return {
                ...state,
                notes: action.payload,
                loadingNotes: false,
                errorNotes: null
            };

        case actions.FETCH_BATCH_NOTES.FAILURE:
            return { ...state, loadingNotes: false, errorNotes: action.payload };

        case actions.CREATE_BATCH_NOTE.REQUEST:
        case actions.UPDATE_BATCH_NOTE.REQUEST:
        case actions.DELETE_BATCH_NOTE.REQUEST:
            return { ...state, loadingNotes: true, errorNotes: null };

        case actions.CREATE_BATCH_NOTE.SUCCESS:
            return {
                ...state,
                notes: [action.payload, ...state.notes],
                loadingNotes: false
            };

        case actions.UPDATE_BATCH_NOTE.SUCCESS:
            return {
                ...state,
                notes: state.notes.map(note =>
                    note.id === action.payload.id ? action.payload : note
                ),
                loadingNotes: false
            };

        case actions.DELETE_BATCH_NOTE.SUCCESS:
            return {
                ...state,
                notes: state.notes.filter(note => note.id !== action.payload.noteId),
                loadingNotes: false
            };

        case actions.CREATE_BATCH_NOTE.FAILURE:
        case actions.UPDATE_BATCH_NOTE.FAILURE:
        case actions.DELETE_BATCH_NOTE.FAILURE:
            return { ...state, loadingNotes: false, errorNotes: action.payload };

        // ==================== IMAGES ====================
        case actions.FETCH_BATCH_IMAGES.REQUEST:
            return { ...state, loadingImages: true, errorImages: null };

        case actions.FETCH_BATCH_IMAGES.SUCCESS:
            return {
                ...state,
                images: action.payload,
                loadingImages: false,
                errorImages: null
            };

        case actions.FETCH_BATCH_IMAGES.FAILURE:
            return { ...state, loadingImages: false, errorImages: action.payload };

        case actions.UPLOAD_BATCH_IMAGE.REQUEST:
        case actions.DELETE_BATCH_IMAGE.REQUEST:
            return { ...state, loadingImages: true, errorImages: null };

        case actions.UPLOAD_BATCH_IMAGE.SUCCESS:
            return {
                ...state,
                images: [action.payload, ...state.images],
                loadingImages: false
            };

        case actions.DELETE_BATCH_IMAGE.SUCCESS:
            return {
                ...state,
                images: state.images.filter(image => image.id !== action.payload.imageId),
                loadingImages: false
            };

        case actions.UPLOAD_BATCH_IMAGE.FAILURE:
        case actions.DELETE_BATCH_IMAGE.FAILURE:
            return { ...state, loadingImages: false, errorImages: action.payload };

        // ==================== UI STATE ====================
        case actions.SET_BATCH_FILTERS:
            return { ...state, filters: { ...state.filters, ...action.payload } };

        case actions.CLEAR_BATCH_DETAIL:
            return { ...state, currentBatch: null, notes: [], images: [] };

        case actions.SET_SELECTED_BATCH:
            return { ...state, selectedBatch: action.payload };

        case actions.CLEAR_BATCH_ERROR:
            return { ...state, errorBatches: null, errorBatchDetail: null };

        default:
            return state;
    }
}
